import { generateApiPath } from "@routes/generatePath.ts";
import type { IExtractApiParams } from "@routes/types.ts";

const pathBase = `/visit-summary-notes/vital-sign/:summaryNoteId/`;
const pathById = `/visit-summary-notes/vital-sign/:vitalSignId/`;

type IPathBaseParams = IExtractApiParams<typeof pathBase>;
type IPathByIdParams = IExtractApiParams<typeof pathById>;

export const vitalSigns = {
  getAll: (params: IPathBaseParams) => generateApiPath(pathBase, params),
  post: (params: IPathBaseParams) => generateApiPath(pathBase, params),
  put: (params: IPathByIdParams) => generateApiPath(pathById, params),
  delete: (params: IPathByIdParams) => generateApiPath(pathById, params),
};
